export default __webpack_public_path__ + "static/media/service.7ebde639.png";